module.exports = __webpack_public_path__ + "img/Cheer Megaphone53.0262b807.jpg";